import { render, staticRenderFns } from "./gzhFixedBody.vue?vue&type=template&id=7bbf221c&scoped=true&"
import script from "./gzhFixedBody.vue?vue&type=script&lang=js&"
export * from "./gzhFixedBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbf221c",
  null
  
)

export default component.exports